module.exports = {"540322100":"莫洛镇","540322200":"相皮乡","540322201":"哈加乡","540322202":"雄松乡","540322203":"拉妥乡","540322204":"阿旺乡","540322205":"木协乡","540322206":"罗麦乡","540322207":"沙东乡","540322208":"克日乡","540322209":"则巴乡","540322210":"敏都乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540322.json
// module id = 2707
// module chunks = 0